export const BASE_GET_TRY = 'BASE_GET_TRY';
export const BASE_GET_OK = 'BASE_GET_OK';
export const BASE_GET_ERROR = 'BASE_GET_ERROR';